import {
  createPlatformState,
  platformAction,
  platformGetters,
  platformMutations
} from '~/helpers/store'

export default {
  state: () => createPlatformState(),
  actions: {
    getInterests ({ commit, state }) {
      if (Object.keys(state.data).length > 0) return Promise.resolve()
      return platformAction({
        client: this.$api.profiles.interests,
        method: 'getAll',
        commit,
        logError: this.$logError,
        include: [],
        params: {
          perPage: 1000
        },
        commitData: true
      })
    }
  },
  getters: {
    ...platformGetters,
    interests: ({ data }) => Object.values(data)
  },
  mutations: {
    ...platformMutations
  }
}
